import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import SiteHeader from './components/layout/SiteHeader';
import SiteFooter from './components/layout/SiteFooter';
import HomePage from './pages/HomePage';
import Experience from './pages/Experience';
import AboutWeldon from './pages/AboutWeldon';
import Media from './pages/Media';
import Contact from './pages/Contact';
import Admin from './pages/Admin';

// DEACTIVATED — Film audit/sales pages (kept for reactivation)
// import FilmAuditServices from './pages/FilmAuditServices';
// import FilmAuditIntakeForm from './components/shared/FilmAuditIntakeForm';
// import ForCoaches from './pages/ForCoaches';
// import ForPlayersParents from './pages/ForPlayersParents';
// import Resources from './pages/Resources';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function SiteLayout({ children }) {
  return (
    <>
      <SiteHeader />
      <main className="min-h-screen">{children}</main>
      <SiteFooter />
    </>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<SiteLayout><HomePage /></SiteLayout>} />
        <Route path="/experience" element={<SiteLayout><Experience /></SiteLayout>} />
        <Route path="/about" element={<SiteLayout><AboutWeldon /></SiteLayout>} />
        <Route path="/media" element={<SiteLayout><Media /></SiteLayout>} />
        <Route path="/contact" element={<SiteLayout><Contact /></SiteLayout>} />
        <Route path="/admin/intake" element={<Admin />} />

        {/* DEACTIVATED — Uncomment to reactivate film audit/sales features
        <Route path="/services" element={<SiteLayout><FilmAuditServices /></SiteLayout>} />
        <Route path="/services/payment-success" element={<SiteLayout><FilmAuditIntakeForm /></SiteLayout>} />
        <Route path="/for-coaches" element={<SiteLayout><ForCoaches /></SiteLayout>} />
        <Route path="/for-players-parents" element={<SiteLayout><ForPlayersParents /></SiteLayout>} />
        <Route path="/proof" element={<SiteLayout><ProofResults /></SiteLayout>} />
        <Route path="/resources" element={<SiteLayout><Resources /></SiteLayout>} />
        */}
      </Routes>
    </Router>
  );
}

export default App;
